/* eslint-disable no-param-reassign */
import { CaseReducer, SliceCaseReducers } from '@reduxjs/toolkit';
import { createSlice } from 'helpers/createSlice';
import { ActionWithPayload } from 'types';

interface ModalRegister {
  id: string;
  props: unknown;
}

type PushPayload = ModalRegister;

type State = Array<ModalRegister>;

interface Reducers extends SliceCaseReducers<State> {
  push: CaseReducer<State, ActionWithPayload<PushPayload>>;
  pop: CaseReducer<State>;
  reset: CaseReducer<State>;
}

const initialState: State = [];

export const emergentModal = createSlice<State, Reducers>({
  name: 'emergentModal',
  initialState,
  reducers: {
    push: (state, { payload }) => {
      state.push(payload);
    },
    pop: (state) => {
      state?.pop();
    },
    reset: () => initialState,
  },
});
